module.exports = __webpack_public_path__ + "static/media/speaker-johnson.6b19da81.jpg";